// libs
import styled from 'styled-components'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// themes
import { colors } from 'themes'
// icons
import CheckedOriginIcon from '@mui/icons-material/Check'
// utils
import { darken, size } from 'polished'

const CheckedIcon = styled(CheckedOriginIcon)`
  margin-left: 8px;
  right: 0;
`

const Header = styled.div`
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  display: flex;

  justify-content: space-between;
  align-items: center;

  flex: 1;
  border-bottom: 1px solid ${colors.blue500};
  position: relative;
  height: 32px;
`

const OptionTitle = styled('div')`
  display: flex;
  font-size: 14px;
  font-weight: bold;

  svg {
    ${size('14px')}
  }
`

const OptionWrapper = styled('div')<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? colors.gray850 : colors.gray300)};
  cursor: pointer;
  font-size: 12px;
  padding: 0 8px;
  margin-bottom: 12px;
  position: relative;

  ${ButtonsWrapper} {
    display: none;
  }

  &:hover {
    ${ButtonsWrapper} {
      display: flex;
    }
  }

  p {
    margin: 0;
  }

  svg:first-child {
    margin-right: 4px;
  }

  svg {
    ${size('16px')}
  }
`

const Wrapper = styled('div')`
  padding: 8px;
  width: 470px;
  min-height: 94px;
  max-height: calc(100vh - 100px);

  > div:first-child {
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  .MuiFormLabel-root {
    font-size: 17px;
  }
`

const ButtonContainer = styled.div`
  font-size: 14px;
  color: ${colors.blue500};
  cursor: pointer;
  display: inline-block;
  font-weight: 500;
  margin-top: 8px;

  &:hover {
    color: ${darken(0.1, colors.blue500)};
  }
`

export { CheckedIcon, Header, OptionTitle, OptionWrapper, Wrapper, ButtonContainer }
